import React, { useEffect, useState } from 'react'
import PayoutBeneFiciaryReportsList from './payoutBeneFiciaryReportsList/PayoutBeneFiciaryReportsList'
import { useParams } from 'react-router-dom'
import Breadcrumbs from '../../common/breadcrumb/Breadcrumbs'
import { payoutBeneficiaryReports } from '../../api/login/Login'
import PayoutBenificiaryReportsFillter from './payoutBeneficiaryReporrtsFillter/PayoutBenificiaryReportsFillter'
import Loadar from '../../common/loader/Loader'
import { ToastContainer } from 'react-toastify'


function PayoutBeneFiciaryReports() {
    const breadCrumbsTitle = {
        id: "1",
        title_1: "Reports",
        title_2: "Payout Beneficiary Reports",
    }
    const [count, setCount] = useState(10)
    const [page, setPage] = useState(0)
    const [aepsData, setAepsData] = useState()
    const [loading, setLoading] = useState(false)
    const [userData, setUserData] = useState(false)
    const token = window.localStorage.getItem('userToken')
    const [reset , setReset]= useState(false)
    const param = useParams()
    const [initialValues, setIntialValues] = useState({
        start_date: "",
        end_date: "",
        approval_type: "",
        status: ""
    })
    const [operatorId, setOpratorID] = useState("")



    const submitForm = async (values) => {

        // setLoading(true);
        setReset((pre)=> !pre)
        setPage(0)
        setIntialValues({
            ...values
        })
        // setPage(0)
        // try {

        //     const res = await payoutBeneficiaryReports({ ...values, page: 0, count, });
        //     setAepsData(res);
        // } catch (error) {
        //     console.error("Error during AEPS transaction filter:", error);
        // } finally {
        //     setLoading(false);
        // }
    };

    const getDmtTxnData = async () => {
        setLoading(true)
        try {
            const res = await payoutBeneficiaryReports({ ...initialValues, page, count, });
            setAepsData(res);
            setLoading(false)
        } catch (error) {
            alert(error.message)
        }
    }




    const onChangeVal = (e) => {
        setPage(e - 1)
        // setTimeout(() => {
        //     getDmtTxnData(e - 1)
        // }, 500);
    };

    useEffect(() => {
        getDmtTxnData()
    }, [page , reset])
    return (
        <> 
        {loading && <Loadar/>}
        <ToastContainer/>
            <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
            <PayoutBenificiaryReportsFillter setReset={setReset}  initialValues={initialValues} setIntialValues={setIntialValues} submitForm={submitForm} aepsData={aepsData} getDmtTxnData={getDmtTxnData} page={page} setPage={setPage} />
            <PayoutBeneFiciaryReportsList setReset={setReset} setLoading={setLoading} page={page} onChangeVal={onChangeVal} aepsData={aepsData} getDmtTxnData={getDmtTxnData} count={count} />
        </>
    )
}

export default PayoutBeneFiciaryReports
